import LegalPageLayout from "./LegalPageLayout";

const PrivacyPolicy = () => (
  <LegalPageLayout
    eyebrow="Legal"
    title="Privacy Policy"
    effectiveDate="22 May 2025"
  >
    <h2>Scope</h2>
    <p>
      This Privacy Policy explains how SpearBI ("we", "us") collects, uses,
      discloses and protects personal information when you use the SpearBI
      Reporting System ("Service").
    </p>

    <h2>Information We Collect</h2>
    <ul>
      <li>
        <strong>Registration Data:</strong> name, email address, organization,
        role, phone number.
      </li>
      <li>
        <strong>Usage Data:</strong> log data, IP address, browser type, pages
        visited, time stamps.
      </li>
      <li>
        <strong>Uploaded Data:</strong> any files or records you import (e.g.,
        sales figures, strike rates).
      </li>
      <li>
        <strong>Cookies &amp; Tracking:</strong> session cookies and analytics
        cookies to improve performance.
      </li>
    </ul>

    <h2>How We Use Information</h2>
    <ul>
      <li>To provide and maintain the Service.</li>
      <li>To authenticate and manage your Account.</li>
      <li>To analyse usage and improve features, reports and UX.</li>
      <li>To send you transactional emails (e.g., password resets, account notifications).</li>
      <li>To comply with legal obligations.</li>
    </ul>

    <h2>Data Sharing &amp; Disclosure</h2>
    <ul>
      <li>
        <strong>Service Providers:</strong> we may share information with
        third-party vendors who perform services on our behalf (hosting,
        analytics, email).
      </li>
      <li>
        <strong>Legal Requirements:</strong> we may disclose information to
        comply with applicable laws or respond to lawful requests.
      </li>
      <li>
        <strong>Business Transfers:</strong> in connection with a merger,
        acquisition, or sale of assets, your Data may be transferred.
      </li>
    </ul>

    <h2>Data Security</h2>
    <p>
      We implement reasonable technical and organizational measures (encryption
      in transit, access controls) to protect your information. However, no
      system is 100% secure — use strong, unique passwords and secure your end.
    </p>

    <h2>Data Retention</h2>
    <p>
      We retain personal information as long as your Account is active plus any
      additional period needed to comply with legal obligations. You may
      request deletion of your Account and data at any time (see Section 9).
    </p>

    <h2>Your Rights</h2>
    <ul>
      <li>
        <strong>Access &amp; Correction:</strong> you can view and update your
        Account information anytime.
      </li>
      <li>
        <strong>Deletion:</strong> you may request erasure of your personal
        information, subject to legal retention requirements.
      </li>
      <li>
        <strong>Objection &amp; Restriction:</strong> you can object to certain
        processing (e.g., analytics).
      </li>
      <li>
        <strong>Data Portability:</strong> you may request a machine-readable
        copy of your data.
      </li>
    </ul>

    <h2>Cookies &amp; Tracking</h2>
    <p>
      You can disable cookies via your browser settings, but this may impact
      Service functionality. For more on cookies we use, see our Cookie Policy
      (if applicable).
    </p>

    <h2>Contact &amp; Complaints</h2>
    <p>
      For privacy inquiries or to exercise your rights, please contact{" "}
      <a href="mailto:privacy@spearbi.org">privacy@spearbi.org</a>. If you're
      not satisfied with our response, you may lodge a complaint with the
      Information Regulator of South Africa.
    </p>

    <h2>Changes to This Policy</h2>
    <p>
      We may update this Privacy Policy. If material changes occur, we'll
      notify you at least 14 days before they take effect. Continued use after
      the effective date means you accept the changes.
    </p>
  </LegalPageLayout>
);

export default PrivacyPolicy;
